/* Conversion Dude - live "children sponsored" counter.

   The number is not available to Liquid: it only exists in the sponsorship
   backend and is read in the browser. Any element can opt in by carrying
   [data-cd-sponsored-count] plus a data-baseline, which is rendered server
   side so a sensible number is on screen before this resolves, and stays
   there if it never does.

   One request per page however many counters are on it. */
(function () {
  var ENDPOINT = 'https://grace-coffee-backend-dev.onrender.com/api/children/sponsor';
  var pending;

  function load() {
    if (!pending) {
      pending = fetch(ENDPOINT, { method: 'GET', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          return data.response && data.response.count != null ? data.response.count : 0;
        });
    }
    return pending;
  }

  function fill(root) {
    var nodes = (root || document).querySelectorAll('[data-cd-sponsored-count]');
    if (!nodes.length) return;

    load().then(function (count) {
      nodes.forEach(function (el) {
        var baseline = parseInt(el.getAttribute('data-baseline'), 10) || 0;
        el.textContent = String(count + baseline);
      });
    }).catch(function () {
      /* Deliberately silent: the server-rendered baseline is already on
         screen, which beats a zero or an error string in front of a
         customer. */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fill(); });
  } else {
    fill();
  }

  document.addEventListener('shopify:section:load', function (e) { fill(e.target); });
})();
